import { render, staticRenderFns } from "./Evolution.vue?vue&type=template&id=6768e9dc&"
import script from "./Evolution.vue?vue&type=script&lang=ts&"
export * from "./Evolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports